import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
// import { FormBuilder, FormGroup, Validators } from '@angular/forms';
// import { ActivatedRoute, Router } from '@angular/router';
// import { ToastrManager } from 'ng6-toastr-notifications';
// import { SharedserviceService } from 'src/app/services';
// import {Sort} from '@angular/material/sort';
// import { CommonService } from 'src/app/services/commonservice.service'
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { SharedserviceService } from 'src/app/services';
import { ToastrManager } from 'ng6-toastr-notifications';
declare var $:any;

@Component({
  selector: 'app-accounts',
  templateUrl: './accounts.component.html',
  styleUrls: ['./accounts.component.scss'],
  providers:[NgxUiLoaderService]

})
export class AccountsComponent implements OnInit {
  list_data: any;
    ngOnInit() {
      }    
  constructor(public sharedService: SharedserviceService , private toastr: ToastrManager
  ) { 
    this.showList();
  }  

  showList(){
    var self = this;
     self.sharedService.get('v1/bank/list').subscribe((res:any) =>{
      if (res.replyCode == "success") {
        this.list_data = res.data.rows;
        console.log("data::::",this.list_data)
      }
     },err=> {
      this.toastr.errorToastr(err.error.replyMsg, "Error");
    })
    
  }


}
